import forumGroupService from "@/services/forumgroup.service";

export const POST_TYPES = {
  Post: "post",
  Scenario: "scenario",
  Media: "media",
};

export const PAGES = {
  None: "none",
  Create: "create",
  Attach: "attach",
  Upload: "upload",
};

const state = () => ({
  postType: POST_TYPES.Post,
  currentPage: PAGES.None,
  scenariosToUpload: [],
  mediaToUpload: [],
  uploadErrors: [],
  scenariosToAttach: [],
  mediaToAttach: [],
  isSubmitting: false,
  title: "",
  postBody: "",
  selectedTags: [],
});

const actions = {
  createPost({ commit }, { isGroup, groupId, formData }) {
    return new Promise((resolve, reject) => {
      forumGroupService
        .createPost(isGroup, groupId, formData)
        .then((response) => {
          if (response.hasOwnProperty("errors") && response.errors.length > 0) {
            commit("setUploadErrors", response.errors);
          }
        })
        .finally(() => {
          commit("setIsSubmitting", false);
          resolve();
        });
    });
  },
  closeModal({ commit }) {
    commit("setPostType", POST_TYPES.Post);
    commit("setCurrentPage", PAGES.None);
    commit("setUploadErrors", []);
    commit("setScenariosToUpload", []);
    commit("setMediaToUpload", []);
    commit("setScenariosToAttach", []);
    commit("setMediaToAttach", []);
    commit("setIsSubmitting", false);
    commit("setTitle", "");
    commit("setPostBody", "");
    commit("setSelectedTags", []);
  },
};

const mutations = {
  setPostType(state, postType) {
    state.postType = postType;
  },
  setCurrentPage(state, newPage) {
    state.currentPage = newPage;
  },
  setUploadErrors(state, errors) {
    state.uploadErrors = errors;
  },
  setScenariosToUpload(state, files) {
    state.scenariosToUpload = files;
  },
  setMediaToUpload(state, files) {
    state.mediaToUpload = files;
  },
  setScenariosToAttach(state, files) {
    state.scenariosToAttach = files;
  },
  setMediaToAttach(state, files) {
    state.mediaToAttach = files;
  },
  setIsSubmitting(state, val) {
    state.isSubmitting = val;
  },
  setTitle(state, val) {
    state.title = val;
  },
  setPostBody(state, val) {
    state.postBody = val;
  },
  setSelectedTags(state, val) {
    state.selectedTags = val;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
